import { render, staticRenderFns } from "./account-item.vue?vue&type=template&id=4db9beb5&scoped=true"
import script from "./account-item.vue?vue&type=script&lang=js"
export * from "./account-item.vue?vue&type=script&lang=js"
import style0 from "./account-item.vue?vue&type=style&index=0&id=4db9beb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9beb5",
  null
  
)

export default component.exports